import type { I18nKey } from 'types/i18n'
import type { RouteConfig } from 'vue-router'

type RouteTabbedConfig<T extends I18nKey> = {
    meta: {
        /**
         * Título que se muestra en el tab
         */
        title: `i18n:${T}`
    }
}
type BreadcrumbConfig = {
    meta: {
        /**
         * Los breadcrumbs que se mostrarán en la página
         */
        breadcrumbs?: { text: string; active?: boolean }[]
    }
}
type ACLRoute = {
    meta: {
        /**
         * Recurso o módulo que controla la ruta
         */
        resource: string
        /**
         * Acción que se puede realizar en la ruta
         */
        action: string
    }
}

/**
 *
 * @param prefix String del prefijo
 * @returns un constructor de strings con el prefijo dado
 */
export const createPrefixer: <P extends string>(prefix: P) => <N extends string>(name: N) => `${P}-${N}` =
    prefix => name =>
        `${prefix}-${name}` as const

export const defineRoutes: <
    TabName extends I18nKey,
    Rt extends RouteConfig & RouteTabbedConfig<TabName> & BreadcrumbConfig & ACLRoute,
>(
    routes: Rt[]
) => Rt[] = routes => routes
